export default "__VITE_ASSET__cb1a715d__"